import dayjs from 'dayjs';
import { IntlShape } from 'react-intl';

type VarighetFormat = 'full' | 'normal' | 'kompakt';

const getSeparatorString = (intl: IntlShape, format: VarighetFormat): string => {
    if (format === 'full') {
        return intl.formatMessage({ id: 'varighet.separator--full' });
    }
    if (format === 'kompakt') {
        return intl.formatMessage({ id: 'varighet.separator--kompakt' });
    }
    return intl.formatMessage({ id: 'varighet.separator--normal' });
};

export const getVarighetString = (antallDager: number, intl: IntlShape, format: VarighetFormat = 'full'): string => {
    const { uker, dager } = getUkerOgDagerFromDager(Math.abs(antallDager));
    const dagerStr = intl.formatMessage(
        { id: 'varighet.dager' },
        {
            dager,
        },
    );
    if (uker === 0) {
        return dagerStr;
    }
    const ukerStr = intl.formatMessage({ id: 'varighet.uker' }, { uker });
    if (dager > 0) {
        return `${ukerStr}${getSeparatorString(intl, format)}${dagerStr}`;
    }
    return ukerStr;
};

const getUkerOgDagerFromDager = (dager: number): { uker: number; dager: number } => {
    const uker = Math.floor(dager / 5);
    return {
        dager: dager - uker * 5,
        uker,
    };
};

export const countWeekdaysBetween = (start: dayjs.Dayjs, end: dayjs.Dayjs) => {
    let count = 0;
    let d = start;

    while (d.isSameOrBefore(end, 'day')) {
        const day = d.day();
        if (day !== 0 && day !== 6) {
            count++;
        }
        d = d.add(1, 'day');
    }

    return count;
};
